
export const HEADER_HEIGHT_DESKTOP = '37px';
export const HEADER_HEIGHT_MOBILE = '35px';
export const NAVIGATE_WIDTH_DESKTOP = '100px';